import { AnchorHotInter } from '@/service/game/entity/anchorHot'
import { GameItemInter } from '@/service/game/entity/gameItem'
import { PlatformCategories } from '@/api/game/type'
import { PlatformCategoriesItemInter } from '@/service/game/entity/gameCategorie'
/** 游戏卡片的形状 */
export enum GameCardShape {
  /** 垂直卡片 */
  Vertical = 'vertical',
  /** 方型卡片 */
  Square = 'square',
  /** 横向卡片 */
  Landscape = 'landscape'
}
/** 游戏卡片的分类 */
export enum GameCardCategory {
  /** 游戏类型 */
  Game = 'game',
  /** 平台类型 */
  Platform = 'platform'
}
/** 卡片通用属性 */
export type GameCardCommonProps = {
  /** 所存在的卡片的类型 */
  inCardShape?: GameCardShape
  /** 该卡片的渲染类型(平台/游戏)
   * 比如热门的平台游戏和普通的游戏,是以GameItem的格式进行返回的,我们在渲染的时候,也要以游戏的格式进行渲染.
   * 普通的平台游戏是以PlatformItem的格式进行返回的,我们在渲染的时候,要以平台的形式进行渲染  */
  inCardRenderCategory: GameCardCategory
  /** 游戏名称 */
  gameName: string
  /** 游戏图片地址 图片测试地址:https://agxxqk-024-ttt-backup.s3.ap-east-1.amazonaws.com/cocos/icon/84/img_hd_dc30.png*/
  imgUrl: string
  /** 游戏log地址 图片测试地址:https://agxxqk-024-ttt-backup.s3.ap-east-1.amazonaws.com/cocos/icon/0/16_N_BG.png?t=1681886028&swRuntimeCacheName=web-lobby-runtime*/
  logoUrl?: string
  /**  背景图片:http://localhost:8082/assets/img_bg1_qp-zr.a0d1d105c21db9930812.png */
  bgImg?: string
  /** 状态:  remenber:推荐 update:更新 newOne:新品 */
  status?: 'remenber' | 'update' | 'newOne' | null
  /** 是否收藏 */
  isFavorited?: boolean
  /** 是否显示收藏图标 */
  isShowFavorited?: boolean
  /** 是否维护中 */
  isMaintain?: boolean
  /** 是否完整图片 (当前完整的图片也可能是后台拼接的,可能不带名字,也可能带名字) */
  isCompleteImage?: boolean
  /** 是否自定义图片 (如果是后端返回的自定义图片,需要单独标出来,因为自定义图片的话,可能不会再拼接名称等其它元素) */
  isCustomIcon?: boolean
  /** 是否在swiper中调用(在swiper中使用,将之加上,快照才能正常使用) */
  isAtSwiper?: boolean
  /** swiper的节点id,指定节点为了提升性能 */
  atSwiperDomId?: string
  /** 点击游戏卡片(注:它只接收直接的函数,不接收由函数返回的函数) */
  handleClickCard?: () => void
  /** 点击收藏功能(注:它只接收直接的函数,不接收由函数返回的函数) */
  handleClickFavorIcon?: () => void
}

/** 卡片数据接口 */
export type CardDataInter =
  | PlatformCategories
  | PlatformCategoriesItemInter
  | GameItemInter
  | AnchorHotInter

/** 卡片数据接口 */
export type CardDataInterArray =
  | Array<GameItemInter | AnchorHotInter>
  | Array<PlatformCategoriesItemInter>

export type CardItemDataInter = GameItemInter &
  AnchorHotInter &
  PlatformCategoriesItemInter

/** 用户自定义props类型 */
export type CustomProps<Data, Props> = {
  // handle开头的是处理事件的函数,它只能传入一个定值,不再不允许由执行函数返回,再传入函数
  [P in keyof Props]?: P extends `${'handle'}${string}`
    ? Props[P]
    : ((params: Data) => Props[P]) | Props[P]
}

/** 生成用户自定义的props 如果传入的是函数,则执行函数,最终给个返回值 */
export const generateCustomProps = <Data, CurProps, Props>(
  data: Data,
  curProps: CurProps,
  custom?: CustomProps<Data, Props>
) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let localCustom: any = {}
  if (custom) {
    localCustom = { ...custom }
    for (const key in localCustom) {
      if (typeof localCustom[key] === 'function') {
        // 是函数,并且不是以handle开头的,就执行该函数,返后取得返回值
        // PS:以handle开头的,本来就要求传入一个回调函数,所以不直接执行它
        if (!key.startsWith('handle')) {
          localCustom[key] = localCustom[key](data, curProps)
        }
      }
    }
  }
  return localCustom as Partial<Props>
}
